import axios from 'axios';
import API_HOST from '../api';

const mapApi = function() {
  const api = {};

  // Basemaps
  api.getBasemaps = function() {
    const url = `${API_HOST}/api/basemap-list`;

    return axios.get(url);
  };

  api.setDefaultBasemap = function(clientId, userId, id) {
    const url = `${API_HOST}/api/client/${clientId}/user/${userId}/basemap/${id}/default`;

    return axios.post(url, null);
  };


  api.getGeoJSONMetadata = function(clientId) {
    const url = `${API_HOST}/api/client/${clientId}/map-geojson-metadata`;

    return axios.get(url);
  };

  api.getForecastTitles = function(productId) {
    const url = `${API_HOST}/api/forecast/list?product-id=${productId}&filter=active`

    return axios.get(url);
  }

  return api;
};

export default mapApi();
